module.exports = __webpack_public_path__ + "static/media/nacos.d96e69f4.png";